// extracted by mini-css-extract-plugin
export default {"container":"Title_container__oDVhg","title":"Title_title__229OP"};